import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { DonorContext } from "../donorProvider";
import { Lightbox } from "../../../shared/components/Lightbox/Lightbox";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { saveDonor } from "../../_queries";
import { useAuth0 } from "@auth0/auth0-react";
import { getAccessToken } from "../../../../hooks/useApi";
import { AlertCircle, Check } from "react-feather";
import { toast } from "react-toastify";
import styles from "./MissingNameModal.module.scss";
export type MissingNameModalConfig = {
  title: string;
  description: string;
  confirm_label: string;
  cancel_label: string;
  failure_message: string;
  success_message: string;
};
export const MissingNameModal: React.FC<{
  config: MissingNameModalConfig;
}> = t0 => {
  const $ = _c(30);
  const {
    config
  } = t0;
  const {
    donor,
    setDonor
  } = useContext(DonorContext);
  const {
    user,
    getAccessTokenSilently
  } = useAuth0();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== donor) {
    t1 = () => {
      if (donor && !donor.name) {
        setOpen(true);
      }
    };
    t2 = [donor];
    $[0] = donor;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== config.failure_message || $[4] !== config.success_message || $[5] !== donor || $[6] !== getAccessTokenSilently || $[7] !== name || $[8] !== setDonor || $[9] !== user) {
    t3 = async () => {
      setLoading(true);
      if (donor && user) {
        const updatedDonor = {
          ...donor,
          name
        };
        const token = await getAccessToken(getAccessTokenSilently);
        const result = await saveDonor(updatedDonor, user, token);
        if (result === null) {
          failureToast(config.failure_message);
        } else {
          successToast(config.success_message);
          setDonor(updatedDonor);
          setOpen(false);
        }
      } else {
        failureToast(config.failure_message);
      }
      setLoading(false);
    };
    $[3] = config.failure_message;
    $[4] = config.success_message;
    $[5] = donor;
    $[6] = getAccessTokenSilently;
    $[7] = name;
    $[8] = setDonor;
    $[9] = user;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const saveName = t3;
  const t4 = name.length > 0;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== config.title) {
    t6 = <h5>{config.title}</h5>;
    $[12] = config.title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== config.description) {
    t7 = <span>{config.description}</span>;
    $[14] = config.description;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== name) {
    t8 = <div className={styles.inputContainer}><EffektTextInput value={name} onChange={setName} /></div>;
    $[16] = name;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className={styles.container}>{t6}{t7}{t8}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== config.cancel_label || $[23] !== config.confirm_label || $[24] !== loading || $[25] !== open || $[26] !== saveName || $[27] !== t4 || $[28] !== t9) {
    t10 = <Lightbox open={open} confirmLabel={config.confirm_label} onConfirm={saveName} valid={t4} loading={loading} cancelLabel={config.cancel_label} onCancel={t5}>{t9}</Lightbox>;
    $[22] = config.cancel_label;
    $[23] = config.confirm_label;
    $[24] = loading;
    $[25] = open;
    $[26] = saveName;
    $[27] = t4;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
const successToast = (msg: string) => toast.success(msg, {
  icon: <Check size={24} color={"black"} />
});
const failureToast = (msg: string) => toast.error(msg, {
  icon: <AlertCircle size={24} color={"black"} />
});